import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '0.75rem',
    padding: '1rem',
    backgroundColor: '#E5F6FD',
    borderRadius: '0.25rem',
  },

  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',

    '& .MuiSvgIcon-root': {
      color: '#0288D1 !important',
    },
  },

  content: {
    width: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',

    '& strong': {
      color: '#014361',
      fontFamily: 'Sora',
      fontWeight: '600',
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },

    '& span': {
      fontFamily: 'Nunito',
      fontWeight: '600 !important',
      fontSize: '0.875rem',
      lineHeight: '1.25rem',
      color: '#014361 !important',
    },

    '& a': {
      color: '#3024E1 !important',
    },
  },

  action: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '0.25rem',
    cursor: 'pointer',
    transition: 'all 300ms ease-in',
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',

    '& strong': {
      fontFamily: 'Sora',
      fontWeight: '800',
      fontSize: '0.75rem',
      lineHeight: '1.5rem',
      color: theme.palette.primary.main,
    },

    '&:hover': {
      backgroundColor: '#cedde3',
    },
  },
}))

export { useStyles }
